import React from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react';

import { EntityRating } from '@kaltura-ott/tvpil-shared';

import AirTimeV2 from 'components/presenters/AirTimeV2/AirTimeV2';
import { ExpirationBadge } from 'components/presenters/Card/components/Label/ExpirationBadge/ExpirationBadge';
import { NewEpisodeBadge } from 'components/presenters/Card/components/Label/NewEpisodeBadge/NewEpisodeBadge';
import { Rating } from 'components/presenters/icons';
import PlayButton from 'components/widgets/buttons/PlayButton/PlayButton';
import { AiringDateProps } from 'components/widgets/CardView/types';
import ProgressBar from 'components/widgets/ProgressBar/ProgressBar';

import styles from './RecordingCardContent.module.scss';
// TODO: need to check the translation from POEditor for aria label
function Content({
  expirationBadgeMessage,
  newEpisodeBadgeMessage,
  episodesCounterMessage,
  progress,
  rating,
  shouldShowRating,
  shouldShowAiringTime,
  shouldShowPlayButton,
  isRecordOngoing,
  airingDateObject
}: {
  expirationBadgeMessage: string | undefined;
  newEpisodeBadgeMessage: string | undefined;
  episodesCounterMessage: string | undefined;
  progress: number | undefined;
  rating: EntityRating | undefined;
  shouldShowRating: boolean;
  shouldShowAiringTime: boolean;
  shouldShowPlayButton: boolean;
  isRecordOngoing: boolean,
  airingDateObject: AiringDateProps | undefined;
}) {

  return (
    <div className={cn(styles.inner, styles.programAsset)}>
      {newEpisodeBadgeMessage && (
        <NewEpisodeBadge message={newEpisodeBadgeMessage} className={styles.newEpisodeBadge} />
      )}

      {expirationBadgeMessage && <ExpirationBadge message={expirationBadgeMessage} className={styles.expires} />}

      {shouldShowPlayButton && <PlayButton data-type='playButton' className={styles.playBtn} />}

      {shouldShowAiringTime && (
        <time role='timer' aria-label='Recording Airing Time' data-type='futureProgram' className={styles.unplayable}>
          <AirTimeV2 showNowLabel={isRecordOngoing} airingDate={airingDateObject} isInfo />
        </time>
      )}
      {((shouldShowRating && rating) || episodesCounterMessage) && (
        <section className={styles.ratingAndEpisodesSection} aria-labelledby='rating-and-episodes-section'>
          {shouldShowRating && rating && (
            <div data-type='ratingInfo' role='status' aria-label='Rating'>
              <Rating rating={rating} />
            </div>
          )}

          {episodesCounterMessage && <span className={styles.episodesCounterWrapper}>{episodesCounterMessage}</span>}
        </section>
      )}

      {!!progress && <ProgressBar className={styles.progressBar} percent={progress} />}
    </div>
  );
}

const RecordingCardContent = observer(Content);

export { RecordingCardContent };
